import React from "react";
import {
  Content,
  Heading,
  ImageWrapper,
  StyledInfographic,
  Value,
  ContentWrapper,
  Summary,
} from "./Infographic.styles";

const Infographic = ({
  title,
  figure,
  image,
  titleColor,
  figureColor,
  imagePosition,
  summary,
  ...rest
}) => {
  return (
    <StyledInfographic {...rest}>
      <Content>
        <ContentWrapper>
          <Heading color={titleColor}>{title}</Heading>
          <Value color={figureColor}>{figure}</Value>
          {summary && <Summary>{summary}</Summary>}
          <ImageWrapper position={imagePosition}>{image}</ImageWrapper>
        </ContentWrapper>
      </Content>
    </StyledInfographic>
  );
};

export default Infographic;
